import React from 'react';
import styled from 'styled-components';

import { ConfirmationModal, ModalPosition, Container, Button } from 'ui/components/styled';

export const AddMemberSuccess = (props) => (
  <ConfirmationModal
    padding="1.5rem 2rem"
    content={ModalContent}
    position={ModalPosition.TOP_CENTER}
    top="25%"
    width="40%"
    maxWidth="600px"
    {...props}
  />
);

const ModalContent = ({ children, onClose, onConfirm, preventConfirm }) => (
  <>
    {children ? (
      <Content mb="l">{children}</Content>
    ) : (
      <>
        <Title mb="xxs">Congrats the user was successfully added!</Title>
        <Content mb="l">
          You can still add more users by clicking on the “Add Another Member”
        </Content>
      </>
    )}
    <Container>
      <Button width="100%" mb="m" onClick={onConfirm} disabled={preventConfirm}>
        Add Another Member
      </Button>
      <Button variant="danger" look="underline" width="100%" onClick={onClose}>
        Finish!
      </Button>
    </Container>
  </>
);

const Title = styled(Container)`
  font-weight: 500;
  font-size: 15px;
  letter-spacing: 0.04em;
  line-height: 26px;
  color: #00aa22;
`;

const Content = styled(Container)`
  font-weight: normal;
  font-size: 15px;
  letter-spacing: 0.04em;
  line-height: 26px;
  color: #888;
`;
